import { Payments_PaymentProcessorId as PaymentProcessorId } from '__generated__/graphql-types';

import {
  PAYMENT_PROCESSOR_ID_BRAINTREE,
  PAYMENT_PROCESSOR_ID_BRAINTREE_SANDBOX,
  PAYMENT_PROCESSOR_ID_PAYPAL,
  PAYMENT_PROCESSOR_ID_RAZORPAY,
  PAYMENT_PROCESSOR_ID_RAZORPAY_SANDBOX,
  PAYMENT_PROCESSOR_ID_STRIPE_BV_CONSUMER,
  PAYMENT_PROCESSOR_ID_STRIPE_BV_CONSUMER_SANDBOX,
  PAYMENT_PROCESSOR_ID_STRIPE_CONSUMER,
  PAYMENT_PROCESSOR_ID_STRIPE_CONSUMER_SANDBOX,
} from 'bundles/payments-common/common/PaymentProcessorIdTypes';
import {
  type PaymentProcessorType,
  braintree,
  braintreeSandbox,
  paypal,
  razorpay,
  razorpaySandbox,
  stripeBvConsumer,
  stripeBvConsumerSandbox,
  stripeConsumer,
  stripeConsumerSandbox,
} from 'bundles/payments-common/common/PaymentProcessorTypes';

/**
 * Get the scala payment processor id from js or graphql payment processor id
 * Note this is not the full mapping
 */
export const getPaymentProcessorId = (paymentProcessor: PaymentProcessorType | PaymentProcessorId) => {
  switch (paymentProcessor) {
    case PaymentProcessorId.Braintree:
    case braintree:
      return PAYMENT_PROCESSOR_ID_BRAINTREE;
    case PaymentProcessorId.BraintreeSandbox:
    case braintreeSandbox:
      return PAYMENT_PROCESSOR_ID_BRAINTREE_SANDBOX;
    case PaymentProcessorId.Paypal:
    case paypal:
      return PAYMENT_PROCESSOR_ID_PAYPAL;
    case PaymentProcessorId.Razorpay:
    case razorpay:
      return PAYMENT_PROCESSOR_ID_RAZORPAY;
    case PaymentProcessorId.RazorpaySandbox:
    case razorpaySandbox:
      return PAYMENT_PROCESSOR_ID_RAZORPAY_SANDBOX;
    case PaymentProcessorId.StripeConsumer:
    case stripeConsumer:
      return PAYMENT_PROCESSOR_ID_STRIPE_CONSUMER;
    case PaymentProcessorId.StripeConsumerSandbox:
    case stripeConsumerSandbox:
      return PAYMENT_PROCESSOR_ID_STRIPE_CONSUMER_SANDBOX;
    case PaymentProcessorId.StripeBvConsumer:
    case stripeBvConsumer:
      return PAYMENT_PROCESSOR_ID_STRIPE_BV_CONSUMER;
    case PaymentProcessorId.StripeBvConsumerSandbox:
    case stripeBvConsumerSandbox:
      return PAYMENT_PROCESSOR_ID_STRIPE_BV_CONSUMER_SANDBOX;
    default:
      return null;
  }
};
